import { render, staticRenderFns } from "./applyDrawback.vue?vue&type=template&id=ddc9daee&scoped=true&"
import script from "./applyDrawback.vue?vue&type=script&lang=js&"
export * from "./applyDrawback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc9daee",
  null
  
)

export default component.exports